/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Safe_TitleInputs */

const da_forside_safe_title = /** @type {(inputs: Forside_Safe_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygget til elevdata`)
};

/** @type {(inputs: Forside_Safe_TitleInputs) => LocalizedString} */
const en_forside_safe_title = da_forside_safe_title;

/**

* @param {Forside_Safe_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_safe_title = /** @type {((inputs?: Forside_Safe_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Safe_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_safe_title(inputs)
	return /** @type {LocalizedString} */ ("Bygget til elevdata")
});